import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as u } from "../interface.js";
import f from "./RenderSorter.js";
import S from "../../../_mixins/use-config.js";
import p from "../../../_internal/icon/src/Icon.js";
import v from "../../../_internal/icons/ArrowDown.js";
import { defineComponent as g, inject as R, computed as d, h as a } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const h = g({
  name: "SortIcon",
  props: {
    column: {
      type: Object,
      required: !0
    }
  },
  setup(o) {
    const {
      mergedComponentPropsRef: e
    } = S(), {
      mergedSortStateRef: t,
      mergedClsPrefixRef: n
    } = R(u), m = d(() => t.value.find((r) => r.columnKey === o.column.key)), c = d(() => m.value !== void 0), l = d(() => {
      const {
        value: r
      } = m;
      return r && c.value ? r.order : !1;
    }), i = d(() => {
      var r, s;
      return ((s = (r = e == null ? void 0 : e.value) === null || r === void 0 ? void 0 : r.DataTable) === null || s === void 0 ? void 0 : s.renderSorter) || o.column.renderSorter;
    });
    return {
      mergedClsPrefix: n,
      active: c,
      mergedSortOrder: l,
      mergedRenderSorter: i
    };
  },
  render() {
    const {
      mergedRenderSorter: o,
      mergedSortOrder: e,
      mergedClsPrefix: t
    } = this, {
      renderSorterIcon: n
    } = this.column;
    return o ? a(f, {
      render: o,
      order: e
    }) : a("span", {
      class: [`${t}-data-table-sorter`, e === "ascend" && `${t}-data-table-sorter--asc`, e === "descend" && `${t}-data-table-sorter--desc`]
    }, n ? n({
      order: e
    }) : a(p, {
      clsPrefix: t
    }, {
      default: () => a(v, null)
    }));
  }
});
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/HeaderButton/SortButton.js
// module id = 1650
// module chunks = 67